class DeliveryTime extends HTMLElement {

    constructor() {
        super();

        this.formatString = this.getAttribute("data-frm-day") || "MMM DD";

        this.excludedDays = (
            this.getAttribute("data-exclude-day") || ""
        )
            .replace(/\s/g, "")
            .split(",")
            .filter(Boolean);

        this.numbDateStart = parseInt(this.getAttribute("data-estimate-start")) || 0;
        this.numbDateEnd = parseInt(this.getAttribute("data-estimate-end")) || 0;

        this.targetTime = this.getAttribute("data-time") || "23:59";

        this.hr = this.querySelector(".productView-dlvr__remaining-hr");
        this.mins = this.querySelector(".productView-dlvr__remaining-mins");
        this.sec = this.querySelector(".productView-dlvr__remaining-sec");

        this.iso_code = document.documentElement.lang || "en-US";

        // Remove hidden class
        // this.classList.remove("d-none");
        // this.style.display = "block";

        // if (this.isTodayExcluded()) {
        //     this.style.display = "none";
        //     return;
        // }

        this.productDeliveryTime();
        this.updateCountdown();

        this.timer = setInterval(() => {
            this.updateCountdown();
        }, 1000);
    }

    disconnectedCallback() {
        clearInterval(this.timer);
    }

    isTodayExcluded() {
        const today = new Date().getDay();

        const days = [
            "SUN",
            "MON",
            "TUE",
            "WED",
            "THU",
            "FRI",
            "SAT"
        ];

        return this.excludedDays.some(day => today === days.indexOf(day));
    }

    updateCountdown() {

    const countdown = this.countdownToTime(this.targetTime);

    console.log("Countdown :", countdown);

    if(this.hr)
        this.hr.innerHTML = String(countdown.hours).padStart(2,'0');

    if(this.mins)
        this.mins.innerHTML = String(countdown.minutes).padStart(2,'0');

    if(this.sec)
        this.sec.innerHTML = String(countdown.seconds).padStart(2,'0');
}

   productDeliveryTime() {

    console.log("productDeliveryTime() called");

    const startDay = this.excludeDays(
        this.excludedDays,
        this.numbDateStart
    );

    const endDay = this.excludeDays(
        this.excludedDays,
        this.numbDateEnd
    );

    console.log("Start Date Object :", startDay);
    console.log("End Date Object :", endDay);

    const formattedStartDate = this.formatDate(
        startDay,
        this.formatString
    );

    const formattedEndDate = this.formatDate(
        endDay,
        this.formatString
    );

    console.log("Formatted Start :", formattedStartDate);
    console.log("Formatted End :", formattedEndDate);

    const startEl = this.querySelector("[data-start-delivery]");
    const endEl = this.querySelector("[data-end-delivery]");

    console.log("Start Element :", startEl);
    console.log("End Element :", endEl);

    if(startEl) startEl.innerHTML = formattedStartDate;
    if(endEl) endEl.innerHTML = formattedEndDate;
}

    formatDate(date, formatString) {

        const weekday = date.toLocaleDateString(this.iso_code, {
            weekday: "long"
        });

        const day = date.toLocaleDateString(this.iso_code, {
            day: "2-digit"
        });

        const month = date.toLocaleDateString(this.iso_code, {
            month: "short"
        });

        const monthNumber = String(date.getMonth() + 1).padStart(2, "0");

        const year = date.getFullYear();

        return formatString
            .replace("YYYY", year)
            .replace("MMM", month)
            .replace("MM", monthNumber)
            .replace("DD", day)
            .replace("d", weekday);
    }

    excludeDays(excludedDays, daysToAdd) {

        const result = new Date();

        result.setHours(0, 0, 0, 0);

        let added = 0;

        while (added < daysToAdd) {

            result.setDate(result.getDate() + 1);

            const currentDay = result.getDay();

            const isExcluded = excludedDays.some(day => {

                return currentDay === [
                    "SUN",
                    "MON",
                    "TUE",
                    "WED",
                    "THU",
                    "FRI",
                    "SAT"
                ].indexOf(day);

            });

            if (!isExcluded) {
                added++;
            }
        }

        return result;
    }

    countdownToTime(targetTime) {

        const now = new Date();

        let target = new Date(`${now.toDateString()} ${targetTime}`);

        if (isNaN(target.getTime())) {
            target = new Date(`${now.toDateString()} 23:59`);
        }

        if (target <= now) {
            target.setDate(target.getDate() + 1);
        }

        const diff = target - now;

        const hours = Math.floor(diff / (1000 * 60 * 60));

        const minutes = Math.floor(
            (diff % (1000 * 60 * 60)) / (1000 * 60)
        );

        const seconds = Math.floor(
            (diff % (1000 * 60)) / 1000
        );

        return {
            hours,
            minutes,
            seconds
        };
    }
}

if (!customElements.get("delivery-time")) {
    customElements.define("delivery-time", DeliveryTime);
}